import React from "react";
import { connect } from "react-redux";
import LoadingAnimation from "../../Utils/loadingAnimation.js";
import SkeltonScreens from "../../Utils/skeltonScreens.js";
import Network from "../../Utils/network.js";
import GeneralUtils from "../../Utils/generalUtils.js";
import { FaCreditCard, FaArrowRight } from "react-icons/fa";
import { Modal, ModalBody, Button } from "reactstrap";
import SliderModal from "../../Utils/sliderModal.js";
import Swal from "sweetalert2";
import NoDataFound from "../../Utils/noDataFound.js";
import Constants from "../../Utils/constants.json";

class PaymentComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileId: "NA",
            isPaymentModalVisible: false,
            manifest: "",
            deviceId: "",
            isCreditDebitCardChecked: false,
            isPaypalChecked: false,
            isDwollaChecked: false,
            isAddCardBtnEnabled: false,
            dwollaCustomerUrl: "",
            dwollaIavToken: "",
            tsysReferenceId: "",
            finalOrderId: "",
            isAutopayEnabled: false,
            paypalClientId: "",
            paypalAmount: "",
            paypalAccessToken: "",
            accountId: "",
            firstName: "",
            lastName: "",
            emailId: "",
            phoneNumber: "",
            paymentFor: "",
            paymentAmount: "",
            finalPaymentAmount: "",
            CCDCPaymentMethodAllowed: false,
            payaplPaymentMethodAllowed: true,
            dwollaPaymentMethodAllowed: false,
            billStartDate: "",
            billEndDate: "",
            billPeriod: "",
            billDueDate: "",
            expiryDate: "",
            paymentReceipt: "",
            ransactionId: "",
            token: "",
            fundingSource: "",
            isSaveCardRequired: false,
            savedCardDetails: [],
            payfromNewCard: false,
            payfromSavedCard: false,
            dwollaFundingSourceId: "",
            dwollaFundingSourceName: "",
            isDwollaCustomerExisting: false,
            dwollaEmailAddress: "",
            dwollaFirstName: "",
            dwollaLastName: "",
            isOtpBtnClicked: false,
            isDwollaLoggedIn: false,
            dwollaOtp: "",
            fundingSourcesArray: [],
            isDwollaVerifiedFSExisting: false,
            isDwollaTandCClicked: false,
            isDwollaTandCModalOpen: false,
            isAccountCreated: false,
            showDwollaTermsAndConditions: false,
            changePaymentMethodClicked: false,
            isSavedCardSelected: false,
            diffAmount: 0,
            cardType: "",
            isPaypalButtonRendered: false,
            powertranzOrderId: "", 
            powertranzTransId: "", 
            powertranzInitialResponse: ""
        };
    }

    generateReceiptNumber = () => {
        var number = Math.floor(100000 + Math.random() * 900000);
        number = "SCM" + number;
        return number;
    };

    changePaymentMethodTo(type) {
        if (type === "savedCards") {
            this.setState({
                changePaymentMethodClicked: true,
            });
        } else if (type === "allMethods") {
            this.setState({
                changePaymentMethodClicked: false,
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
        // window.removeEventListener("message", this.processMessage);
        window.removeEventListener("message", this.processIframeMessage);
        clearInterval(this.pollingInterval);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.removeEventListener("resize", this.updateWindowDimensions);
        window.removeEventListener("message", this.processIframeMessage);

        window.addEventListener("resize", this.updateWindowDimensions);
        window.addEventListener("message", this.processIframeMessage);

        var finalAmount = "0.00";
        if (parseFloat(this.props.amount) > 0) finalAmount = this.props.amount;
        var finalPaymentAmountFromProps = parseFloat(finalAmount.replace(",", ""));

        this.setState({
            isLoading: true,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            billId: this.props.billId,
            paymentAmount: finalAmount,
            finalPaymentAmount: finalPaymentAmountFromProps,
            accountId: this.props.accountId,
            billStartDate: this.props.billStartDate,
            billEndDate: this.props.billEndDate,
            billPeriod: this.props.billPeriod,
            phoneNumber: this.props.phoneNumber,
            emailId: this.props.emailId,
            billDueDate: this.props.billDueDate,
            profileId: this.props.profileId,
            dwollaEmailAddress: this.props.emailId,
            dwollaFirstName: this.props.firstName,
            dwollaLastName: this.props.lastName,
        });

        Network.executeAxios("FetchChannelPaymentMethods", "GET", "", (channelPaymentMethodsResponse) => {
            this.manageChannelPaymentMethods(channelPaymentMethodsResponse);
            Network.executeAxios("fetchSavedCardDetails", "POST", "", (saveCardResponse) => {
                this.initializeSavedCardsForCCDC(saveCardResponse);
                //  Network.executeAxios("getManifest", "POST","", (manifestResponse) => {
                //     this.handleManifestResponse(manifestResponse);
                var receivedAmount = parseFloat(this.state.paymentAmount.replace(",", ""));
                if (parseFloat(this.state.finalPaymentAmount) > parseFloat(receivedAmount)) {
                    var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount);
                }

                Network.executeAxios("getPaypalClientId", "GET", "", (response) => {
                    this.setState({
                        paypalClientId: response.CLIENT_ID,
                        paypalAmount: GeneralUtils.formatNumberToStandardForm(
                            this.state.finalPaymentAmount,
                            this.props.configurationValues
                        ),
                        isPaymentModalVisible: true,
                        isLoading: false,
                        diffAmount: diffAmount,
                    });
                });
                //});
            });
        });
    }

    processIframeMessage = (event) => {
        // console.log("event data >> ",event.data);
        // set interval call status
        setTimeout(() => {
            this.pollingInterval = setInterval(() => this.checkCallbackStatus(event.data.orderId, event.data.transId), 3000);
        }, 2000);
    };

    checkCallbackStatus(orderId,transId) {
        Network.executeAxios("powertranzPaymentComplete", "POST", { orderId: orderId , transId : transId}, (response) => {
            // console.log("response >> ",response);
            if (response.paymentDetails && response.paymentDetails.status !== "INITIATED") {
                console.log("paymentComplete response >> ", response);
                clearInterval(this.pollingInterval);
                var reason = response.paymentDetails.reason;
                if (reason === "bill_payment") {
                    reason = "bill";
                } else if (reason === "recharge") {
                    reason = "recharge";
                } else if (reason === "add_addon") {
                    reason = "addon subscription";
                } else if (reason === "change_plan") {
                    reason = "change plan";
                }
                if (response.paymentDetails.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Successful",
                            html: "<div>Your payment for " + reason + " has been successful</div><div style='text-align:center'>Order Id : " + response.paymentDetails.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "FAILED") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Failed",
                            html: "<div>Your payment for " + reason + " has been Failed</div><div style='text-align:center'>Order Id : " + response.paymentDetails.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "TO_REFUND") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Failed to place the order",
                            html: "<div>Amount debited will be refunded within 2 working days</div>",
                            type: '',
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                }
            } else {
                console.log("waiting for callback...");
            }
        });
    }

    processMessage = (event) => {
        if (event.data.isPaypalButtonRendered) {
            setTimeout(() => {
                this.setState({ isPaypalButtonRendered: true });
            }, 1500);
        } else {
            this.setState({ isPaypalButtonRendered: false });
        }

        if (event.data.responseCode && event.data.responseCode != "") {
            //var self=this;    casting (now we can call functions like self.function())
            if (event.data.status === "PASS") {
                var expiryDate = event.data.expirationDate;
                var cvv = event.data.cvv2;
                var cvvValue = cvv.trim();
                expiryDate = expiryDate.replace("/", "");
                this.setState({
                    isAddCardBtnEnabled: true,
                });
                this.setState({
                    amount: GeneralUtils.formatNumberToStandardForm(
                        this.state.finalPaymentAmount,
                        this.props.configurationValues
                    ),
                    tsysToken: event.data.tsepToken,
                    expiryDate: expiryDate,
                    cvv: cvvValue,
                    lastFourDigit: event.data.maskedCardNumber,
                });
            } else {
                Swal.fire("Invalid Card", "", "");
            }
        } else if (event.data.type && event.data.type === "paypal") {
            this.setState({
                isLoading: true,
            });
            var receiptNumber = this.generateReceiptNumber();
            var response = event.data.details;
            if (response.status === "COMPLETED") {
                // success case
                this.state.transactionId = response.purchase_units[0].payments.captures[0].id; //transaction or capture id
                this.handlePostTransactionOfChannels("9", "PAYPAL", receiptNumber);
            } else {
                this.paymentFailedProcess("PAYPAL", receiptNumber);
            }
        } else {
            console.log("message => ", event.data);
        }
    };

    initializeSavedCardsForCCDC(receivedResponse) {
        var autoPaymentDetails = [];
        try {
            autoPaymentDetails = receivedResponse.BillingSystem.response.dataset.autoPaymentDetails;
        } catch (e) {
            autoPaymentDetails = [];
        }
        this.setState({
            savedCardDetails: autoPaymentDetails,
        });
    }

    manageChannelPaymentMethods(channelPaymentMethodsResponse) {
        try {
            if (
                channelPaymentMethodsResponse &&
                channelPaymentMethodsResponse.BillingSystem &&
                channelPaymentMethodsResponse.BillingSystem.result_code &&
                channelPaymentMethodsResponse.BillingSystem.result_code == "0"
            ) {
                var channelPaymethodAllowedArray =
                    channelPaymentMethodsResponse.BillingSystem.response.dataset.channel_payment_info;
                for (var i = 0; i < channelPaymethodAllowedArray.length; i++) {
                    if (channelPaymethodAllowedArray[i].payment_method_id == "1") {
                        this.state.CCDCPaymentMethodAllowed = true;
                    }
                    if (channelPaymethodAllowedArray[i].payment_method_id == "9") {
                        this.state.payaplPaymentMethodAllowed = true;
                    }
                    if (channelPaymethodAllowedArray[i].payment_method_id == "8") {
                        this.state.dwollaPaymentMethodAllowed = true;
                    }
                }
            }
        } catch (e) {
            console.log("exception", e);
            this.state.CCDCPaymentMethodAllowed = true;
        }
    }

    handleManifestResponse(manifestResponse) {
        var deviceIdToSend = manifestResponse.deviceId;
        manifestResponse = manifestResponse.response;
        var manifestValue = "";
        try {
            if (manifestResponse.entityorAttribute && manifestResponse.entityorAttribute.characteristic) {
                manifestValue = manifestResponse.entityorAttribute.characteristic[0].value;
            }
        } catch (err) {
            manifestValue = "";
        }

        this.setState({
            manifest: manifestValue,
            deviceId: deviceIdToSend,
        });
    }

    updateWindowDimensions = () => {
        console.log("updating window diamentions");
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    };

    paymentModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.setState({ isPaymentModalVisible: false, isAddCardBtnEnabled: false });
            this.props.callbackFromParent(false);
        }
    };

    handleInputValueChange(name, value) {
        const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/);
        if (validated) {
            this.state.finalPaymentAmount = value;
            this.state.paypalAmount = value;
            var receivedAmount = parseFloat(this.state.paymentAmount.replace(",", ""));
            if (parseFloat(this.state.finalPaymentAmount) > parseFloat(receivedAmount)) {
                var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount);
            }

            this.setState({
                diffAmount: diffAmount,
            });
        }
    }

    paymentFailedProcess(paymentTypeName, receiptNumber) {
        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: GeneralUtils.formatNumberToStandardForm(
                this.state.finalPaymentAmount,
                this.props.configurationValues
            ),
            transactionId: "",
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType,
        };
        Network.executeAxios("insertPaymentDetails", "POST", dataToSend, (Response) => {
            if (Response.STATUS === "SUCCESS") {
                Swal.fire("Payment Failed", "", "");
            }
        });
    }

    handlePostTransactionOfChannels(paymentTypeId, paymentTypeName, receiptNumber) {
        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: this.state.finalPaymentAmount,
            diffAmount: this.state.diffAmount,
            transactionId: this.state.transactionId,
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            billAmount: this.state.paymentAmount,
            paymentMethodId: paymentTypeId,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType,
        };
        Network.executeAxios("makePaymentOrder", "POST", dataToSend, (makePaymentOrderResponse) => {
            this.setState({ isLoading: false });
            if (makePaymentOrderResponse.STATUS === "SUCCESS") {
                Swal.fire({
                    title: this.props.locales.paymentSuccessTitleInSwal,
                    text: this.props.locales.paymentCreditTextInSwal,
                    type: "",
                    timer: 2000,
                    showCancelButton: false,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                }).then((result) => {
                    window.location.reload();
                });
            } else {
                this.refundOfTransaction(paymentTypeName);
            }
        });
    }

    plugNpayBtnClicked() {
        this.setState({ isLoading: true });
        this.props.hideBillingAndPaymentPart(true);
        var dataToSend = {
            accountId: this.state.accountId,
            amount: this.state.finalPaymentAmount,
            billingName: this.state.firstName + " " + this.state.lastName,
        };
        Network.executeAxios("payBillWithPowertranz", "POST", dataToSend, (Response) => {
            this.setState({ isLoading: false });
            if(Response.STATUS === "SUCCESS"){
                // console.log("powertranzInitialResponse >> "+Response.redirectData);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // smooth scroll
                });
                this.setState({ 
                    powertranzOrderId: Response.OrderIdentifier, 
                    powertranzTransId: Response.TransactionIdentifier, 
                    powertranzInitialResponse: Response.redirectData 
                });
            } else {
                Swal.fire("Please try again later.");
            }
        // Network.executeAxios("payBillWithPlugNPay", "POST", dataToSend, (Response) => {
            // this.setState({ isLoading: false, plugNPayInitialResponse: Response });
            // window.location.replace(
            //     "./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse))
            // );
        });
    }

    refundOfTransaction(paymentTypeName) {
        this.setState({ isLoading: false });
        Swal.fire({
            title: this.props.locales.paymentFailureTitleInSwal,
            text: this.props.locales.paymentRefundtTextInSwal,
            type: "",
            showCancelButton: false,
            confirmButtonText: "Ok",
        }).then((result) => {
            var refundData = {
                transactionId: this.state.transactionId,
                amount: GeneralUtils.formatNumberToStandardForm(
                    this.state.finalPaymentAmount,
                    this.props.configurationValues
                ),
            };
            if (paymentTypeName == "PAYPAL") {
                Network.executeAxios("paypalRefundPayment", "POST", refundData, (makePaymentOrderResponse) => {
                    window.location.reload();
                });
            }
        });
    }

    modalCancelButtonClicked = () => {
        //credit / debit card
        var paymentDetailArray = [];
        var paymentDetailObjectInsideArray = {
            payment_mode: "10",
            reference_external_id: this.state.tsysReferenceId,
            amount_paid: GeneralUtils.formatNumberToStandardForm(
                this.state.totalMonthlyCharges,
                this.props.configurationValues
            ),
        };
        paymentDetailArray.push(paymentDetailObjectInsideArray);
        // var paymentDetailsToSend = {
        //     upfront_payment: true,
        //     payment_received: true,
        //     amount_paid: GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges),
        //     currency_code: "USD",
        //     payment_detail: paymentDetailArray
        // }

        // var autopayValue = ""
        // if (this.state.isAutopayEnabled) {
        //     autopayValue = 1
        // } else {
        //     autopayValue = 0
        // }

        // var cardDetailsToSend = {
        //     amount: this.state.amount,
        //     token: this.state.tsysToken,
        //     expiryDate: this.state.expiryDate,
        //     cvv: this.state.cvv,
        //     lastFourDigit: this.state.lastFourDigit
        // }
        this.setState({
            isPaymentReceiptModalVisible: false,
            isLoading: true,
        });
    };

    render() {
        return (
            <div className="animated fadeIn col-md-12 p-0 m-0">
                {this.state.skeltonScreenLoading ? SkeltonScreens.skeltonScreenForMyAccountAddServiceAddress() : null}
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {!this.state.skeltonScreenLoading ? this.componentContent() : null}
            </div>
        );
    }

    renderPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe
                    title="payment"
                    src={
                        "./plugNPay.html?responseData=" +
                        encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse))
                    }
                    style={{ width: "100%", border: "none", height: 1100 }}
                    className=""
                >
                    {" "}
                </iframe>
            </div>
        );
    };

    renderPowertranzPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe title="powertranz" 
                    srcDoc={this.state.powertranzInitialResponse} 
                    style={{ width: "100%", border: "none", height:1100 }}>
                    {" "}
                </iframe>
            </div>
        );
    };

    componentContent() {
        return (
            <>
                {this.state.powertranzInitialResponse ? (
                    this.renderPowertranzPaymentPart()
                // {this.state.plugNPayInitialResponse ? (
                //     this.renderPaymentPart()
                ) : (
                    <div className="">
                        <SliderModal
                            isVisible={this.state.isPaymentModalVisible}
                            uniqueModalReferenceId="paymentModal"
                            mainHeading="Payment"
                            leftPartFlexValue={1}
                            rightPartFlexValue={1}
                            isResetButtonVisible={false}
                            isSubmitButtonVisible={false}
                            cancelButtonText="Back"
                            contentPartBackgroundColor="#FFFFFF"
                            isValidationRequired={false}
                            isOnboardingPayment={true}
                            isButtonGroupRequired={true}
                            callback={this.paymentModalHandler}
                        >
                            <div className="col-md-12 p-0">
                                <div className="col-md-12 pr-0">
                                    <div className="col-md-12 pl-0 pr-0">
                                        {this.state.billDueDate.indexOf("000") < 0 ? (
                                            <div className="col-md-12 p-0 py-3" style={{ backgroundColor: "#F4F8F9" }}>
                                                <div className="col-md-12 row m-0 py-2">
                                                    <div className="col-md-6 row m-0">
                                                        <span className="paymentTopLebel">Account Number :</span>
                                                        <span className="paymentTopValues">{this.state.accountId}</span>
                                                    </div>
                                                    <div className="col-md-6 row m-0">
                                                        <span className="paymentTopLebel">Due Date :</span>
                                                        <span className="paymentTopValues">
                                                            {this.state.billDueDate}
                                                        </span>
                                                    </div>
                                                    {/* <div className="col-md-6 row m-0 p-0">
                                        <span className="paymentTopLebel">Bill Cycle :</span>
                                        {this.state.billPeriod != "" && this.state.billPeriod != null && this.state.billPeriod != undefined ?
                                            <span className="paymentTopValues">{this.state.billPeriod}</span>
                                        :
                                            <span className="paymentTopValues">{this.state.billStartDate}-{this.state.billEndDate}</span>
                                        }
                                    </div> */}
                                                </div>
                                                <div className="col-md-12 row m-0 pb-2">
                                                    <div className="col-md-6 row m-0">
                                                        <span className="paymentTopLebel">Total Due :</span>
                                                        <span className="paymentTopValues" style={{ color: "#E31937" }}>
                                                            {this.state.paymentAmount}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="col-md-12 pl-0 pt-3 px-3">
                                            <div className="col-md-6 paymentTopValues mb-2">Pay Now</div>
                                            <div className="col-md-6 form-group">
                                                <input
                                                    type="text"
                                                    className="form-control formGroup_value "
                                                    value={this.state.finalPaymentAmount}
                                                    style={{ boxShadow: "unset", outline: "none" }}
                                                    onChange={(event) =>
                                                        this.handleInputValueChange(
                                                            "finalPaymentAmount",
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {parseFloat(this.state.diffAmount) > 0 ? (
                                            <div
                                                className="col-md-12 px-4 ml-2"
                                                style={{ fontSize: 14, color: "#58595B" }}
                                            >
                                                {Constants.dollarSign}
                                                {GeneralUtils.formatNumberToStandardForm(
                                                    this.state.diffAmount,
                                                    this.props.configurationValues
                                                )}{" "}
                                                {this.props.locales.advancePaymentLabelInPaymentSlider}
                                            </div>
                                        ) : null}

                                        {/* <div className="tsysContainer col-md-8 mt-5" style={parseFloat(this.state.paypalAmount) > 0 ? { height: 76, visibility: 'visible' } : { height: 76, visibility: 'hidden' }}>
                                    <iframe title="" src={"./PayPal.html?clientId=" + this.state.paypalClientId + "&amount=" + this.state.paypalAmount} style={{ width: '100%', border: 'none' }} className={this.state.isPaypalButtonRendered ? "payPalButtonRendered" : "paypalBtnPreRendered"} frameBorder="0"> </iframe>
                                </div> */}
                                        {parseFloat(this.state.paypalAmount) > 0 ? (
                                            <div className="col-md-12 px-3 pt-4 pl-4 ml-2">
                                                <Button
                                                    className="pluNPayBtn animated fadeIn"
                                                    style={{ width: 300, height: 42 }}
                                                    onClick={() => {
                                                        this.plugNpayBtnClicked();
                                                    }}
                                                >
                                                    Pay&nbsp;
                                                    <FaArrowRight />
                                                </Button>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </SliderModal>

                        <Modal isOpen={this.state.isPaymentReceiptModalVisible} size="md" centered>
                            <ModalBody style={{ height: "100%" }}>
                                <button
                                    type="button"
                                    className="close"
                                    style={{
                                        position: "absolute",
                                        top: 3,
                                        right: 10,
                                        cursor: "pointer",
                                        zIndex: 1000,
                                        color: "#E21736",
                                        outline: "none",
                                    }}
                                    onClick={() => {
                                        this.modalCancelButtonClicked();
                                    }}
                                >
                                    <span aria-hidden="false" style={{ fontSize: 30 }}>
                                        &times;
                                    </span>
                                </button>
                                <div style={{ zIndex: 1090 }}>
                                    <div
                                        className=" text-center"
                                        style={{
                                            marginBottom: 14,
                                            borderBottom: "1px solid #eaedf0",
                                            fontSize: 25,
                                            padding: "25px 25px 18px 25px",
                                            marginLeft: 32,
                                            marginRight: 32,
                                            fontWeight: "bold",
                                            color: "#E21736",
                                        }}
                                    >
                                        Receipt
                                    </div>
                                    <div style={{ width: "100%", height: "100%", padding: 20 }}>
                                        <div
                                            style={{ textAlign: "center", fontWeight: 500, wordSpacing: 6 }}
                                            dangerouslySetInnerHTML={{ __html: this.state.paymentReceipt }}
                                        />
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        configurationValues: state.configurationValues,
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

const PaymentComponentContainer = connect(mapStateToProps, mapDispatchToProps)(PaymentComponent);

export default PaymentComponentContainer;
